import { Box } from '@mui/material';
import React from 'react';

import { Address as AddressModel } from '../../../domain/address';

type Props = {
  address: AddressModel;
  // When true, the street address is rendered without data-private (business
  // address, safe to record). Defaults to false for personal/officer addresses.
  isPublic?: boolean;
};

const AddressView: React.FC<Props> = ({
  address: { streetAddress, streetAddress2, city, state, zip },
  isPublic = false,
}: Props) => {
  return (
    <Box>
      <div data-private={!isPublic || undefined}>
        {streetAddress}
        <span> </span>
      </div>
      {streetAddress2 && (
        <div data-private={!isPublic || undefined}>
          {streetAddress2}
          <span> </span>
        </div>
      )}
      <div>{`${city}, ${state} ${zip}`}</div>
    </Box>
  );
};

export { AddressView };
